export default __webpack_public_path__ + "static/media/flourishing_navy_petal.8dcb58be.svg";